import { getIsMobileOrTablet } from '../utils/device.util';

/**
 * Abstract base class that provides `isMobileOrTablet` and `isTouch` getters.
 * Extend any component that needs touch/mobile detection to avoid repeating these two getters.
 */
export abstract class MobileDetectionMixin {
  get isMobileOrTablet(): boolean {
    return getIsMobileOrTablet();
  }

  get isTouch(): boolean {
    return this.isMobileOrTablet;
  }
}
